export default {
  SET_TOKEN_STATUS(state, { status }) {
    state.tokenStatus = status;
  },
};
